<template>
  <div class="card mb-5 mb-xl-10">
    <div class="card-body">
      <!-- Debug temporaire -->
      <div v-if="!rg" class="alert alert-warning">
        ⚠️ Aucun ResponseGroup reçu en props
      </div>
      
      <div v-if="rg">
        <!-- Debug info -->
        <div class="mb-3">
          <small class="text-muted">
            📊 Données reçues: {{ rg ? 'Oui' : 'Non' }} | 
            Responses: {{ rg.responses ? rg.responses.length : 0 }}
          </small>
        </div>
        
        <div v-if="rg.responses && rg.responses.length > 0">
          <table class="table table-striped w-100 g-2">
            <tbody>
              <tr
                class="bg-hover-light-primary"
                v-for="response in rg.responses"
                :key="response.uuid"
              >
                <td class="fw-bolder">
                  {{ response.questionLabel }}
                </td>
                <td v-if="response.value && response.value !== '' && response.value !== null">
                  {{ response.value }}
                </td>
                <td v-else-if="response.responseGroups && response.responseGroups.length > 0">
                  <ResponseDataTable
                    v-for="subRg in response.responseGroups"
                    :key="subRg.uuid"
                    :rg="subRg"
                  />
                </td>
                <td v-else>-</td>
                <td>
                  <div v-if="hasRole('ROLE_ADMIN')" class="btn btn-icon btn-danger btn-xs" @click="deleteResponse(response)">
                    <i class="fad fa-trash-alt"></i>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        
        <div
          v-else
          class="d-flex justify-content-center align-items-center p-10 flex-column"
        >
          <i class="fad fa-empty-set fs-3x"></i>
          <p class="mt-5 fs-2">Aucune donnée de réponse</p>
          <small class="text-muted">Les réponses sont vides ou non chargées</small>
        </div>
      </div>
    </div>
  </div>
</template>
  <script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import Base from "@/layouts/Base.vue";
import Loading from "@/components/Loading.vue";
import UserView from "@/components/UserView.vue";
import VueMultiselect from "vue-multiselect/src/Multiselect.vue";
import ResponseGroup from "@/entity/ResponseGroup";
import {api} from '@/services/Api'

@Component({
  components: { VueMultiselect, Loading, Base, UserView },
})
export default class ResponseDataTable extends Vue {
  @Prop({ default: null }) readonly rg!: ResponseGroup;

  async deleteResponse(response){
    // const res = await api.get(api.form,'response/reset/'+response.uuid)
    // if(res.data.status === 'success'){
      this.$emit('deleteResponse',response.uuid)
    // }
  }
}
</script>
  <style scoped>
</style>
  